import axios from "axios";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import ClipLoader from "react-spinners/ClipLoader";
import Footer from "../../Footer";

function AddVideoCategory() {
  const history = useHistory();
  const { token } = isAutheticated();

  // Form States
  const [inputText, setInputText] = useState({
    channelName: "",
    ownerName: "",
    email: "",
  });

  // Default placeholders
  const BannerURl =
    "https://res.cloudinary.com/duenuiiav/image/upload/v1738589369/tellytell/content_category/xqznnuqh7g6ozepkorzy.png";
  const ThumbnailURl =
    "https://res.cloudinary.com/duenuiiav/image/upload/v1738589368/tellytell/content_category/tpa6shtnfp9txuekeawo.png";

  // Image States
  const [thumbnail, setThumbnail] = useState(null);
  const [uploadLogo, setUploadLogo] = useState(null);
  const [banner, setBanner] = useState(null);

  // UI States
  const [loading, setLoading] = useState(false);
  const wordLimit = { name: 50 };
  const [nameLen, setNameLen] = useState(wordLimit.name);

  // Billing State for Network Channel
  const [billing, setBilling] = useState({
    registrationFee: "",
    paymentType: "",
    monthlyFee: "",
    sixMonthFee: "",
    bandwidth: "",
    space: "",
    channelFee: "",
  });

  // Billing State for Channel
  const [billingChannel, setBillingChannel] = useState({
    Channel_registrationFee: "",
    channel_monthlyFee: "", // removed channel_paymentType
    channel_sixMonthFee: "",
    channel_bandwidth: "",
    channel_space: "",
  });

  // Validations
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleInputText = (e) => {
    setInputText({
      ...inputText,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e, type) => {
    const file = e.target.files[0];
    if (type === "thumbnail") setThumbnail(file);
    if (type === "banner") setBanner(file);
    if (type === "uploadLogo") setUploadLogo(file);
  };

  const removeImage = (type) => {
    if (type === "thumbnail") setThumbnail(null);
    if (type === "banner") setBanner(null);
    if (type === "uploadLogo") setUploadLogo(null);
  };

  const handleEdit = (e) => {
    const length = e.target.value.length;
    if (wordLimit.name - length >= 0) {
      handleInputText(e);
      setNameLen(wordLimit.name - length);
    }
  };

  // Billing handlers
  const handleBillingChange = (e) => {
    setBilling({ ...billing, [e.target.name]: e.target.value });
  };
  const handleBillingChannelChange = (e) => {
    setBillingChannel({ ...billingChannel, [e.target.name]: e.target.value });
  };

  // Total Calculation
  const total =
    (parseFloat(billing.registrationFee) || 0) +
    (billing.paymentType === "monthly"
      ? parseFloat(billing.monthlyFee) || 0
      : parseFloat(billing.sixMonthFee) || 0) +
    (parseFloat(billing.channelFee) || 0);

  const totalChannel =
    (billingChannel.paymentType === "monthly"
      ? parseFloat(billingChannel.monthlyFee) || 0
      : parseFloat(billingChannel.sixMonthFee) || 0) +
    (parseFloat(billingChannel.channelFee) || 0);

  const submitHandler = async (e) => {
    e.preventDefault();

    // Validation for mandatory fields
    if (!inputText.channelName) {
      swal("Warning", "Channel Name is mandatory.", "error");
      return;
    }
    if (!inputText.email || !isValidEmail(inputText.email)) {
      swal("Warning", "Please enter a valid email address.", "error");
      return;
    }
    if (!billing.registrationFee) {
      swal("Warning", "One Time Registration Fee is mandatory.", "error");
      return;
    }


    // If Monthly selected, monthlyFee is required
    if (billing.paymentType === "monthly" && !billing.monthlyFee) {
      swal("Warning", "Monthly Fee is mandatory.", "error");
      return;
    }

    // If 6 Months selected, sixMonthFee is required
    if (billing.paymentType === "sixMonths" && !billing.sixMonthFee) {
      swal("Warning", "6-Month Fee is mandatory.", "error");
      return;
    }
    // Must select payment type
    if (!billing.paymentType) {
      swal("Warning", "Please select a Network Subscription payment type (Monthly or 6 Months).", "error");
      return;
    }
    if (!billing.bandwidth) {
      swal("Warning", "Bandwidth is mandatory.", "error");
      return;
    }
    if (!billing.space) {
      swal("Warning", "Space is mandatory.", "error");
      return;
    }
    if (!billingChannel.Channel_registrationFee) {
      swal("Warning", "Channel One Time Registration Fee is mandatory.", "error");
      return;
    }
    if (!billingChannel.channel_monthlyFee) {
      swal("Warning", "Channel Monthly Fee is mandatory.", "error");
      return;
    }
    if (!billingChannel.channel_sixMonthFee) {
      swal("Warning", "Channel 6-Month Fee is mandatory.", "error");
      return;
    }
    if (!billingChannel.channel_bandwidth) {
      swal("Warning", "Channel Bandwidth is mandatory.", "error");
      return;
    }
    if (!billingChannel.channel_space) {
      swal("Warning", "Channel Space is mandatory.", "error");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("channelName", inputText.channelName);
    formData.append("ownerName", inputText.ownerName);
    formData.append("email", inputText.email);

    if (thumbnail) formData.append("thumbnail", thumbnail);
    if (banner) formData.append("banner", banner);
    if (uploadLogo) formData.append("logo", uploadLogo);

    // Billing details
    formData.append("billing", JSON.stringify(billing));
    formData.append("billingSubchannel", JSON.stringify(billingChannel));

    try {
      const res = await axios.post(`${API}/api/channel/add_channel`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data) {
        swal("Success", "Network Channel added successfully!", "success").then(
          () => {
            history.push("/network_channels");
          }
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        "Failed to add Channel!";
      swal("Error", errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Content Management - Network Channel</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">SoComOTT</Link>
                    </li>
                    <li className="breadcrumb-item">Add New Network Channel</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* Main Form */}
          <div className="row">
            {/* Left: Channel Form */}
            <div className="col-lg-7">
              <div className="card">
                <div className="card-body">
                  <h1 className="text-left head-small">Add New Network Channel</h1>
                  <form onSubmit={submitHandler}>
                    {/* Channel Name */}
                    <div className="form-group">
                      <label>
                        Network Channel Name<span className="text-danger">*</span>
                      </label>
                      <input
                        name="channelName"
                        type="text"
                        className="form-control input-field"
                        onChange={handleEdit}
                        value={inputText.channelName}
                      />
                      <small className="text-secondary">
                        Remaining characters: {nameLen}
                      </small>
                    </div>

                    {/* Owner Name */}
                    <div className="form-group">
                      <label>
                        Network Channel Administrator Name
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        name="ownerName"
                        type="text"
                        className="form-control input-field"
                        onChange={handleInputText}
                        value={inputText.ownerName}
                        required
                      />
                    </div>

                    {/* Email */}
                    <div className="form-group">
                      <label>
                        Network Channel Administrator Email{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        name="email"
                        type="email"
                        className="form-control input-field"
                        onChange={handleInputText}
                        value={inputText.email}
                        required
                      />
                    </div>

                    {/* Thumbnail */}
                    <div className="form-group">
                      <label>Thumbnail (320x180 px)</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => handleImageChange(e, "thumbnail")}
                        accept="image/*"
                      />
                      <div className="preview-container mt-2" style={{ width: "30%" }}>
                        <img
                          src={
                            thumbnail
                              ? URL.createObjectURL(thumbnail)
                              : ThumbnailURl
                          }
                          alt="Thumbnail Preview"
                          className="img-fluid"
                          style={{ maxWidth: "150px", borderRadius: "8px" }}
                        />
                        {thumbnail && (
                          <button
                            type="button"
                            className="btn btn-danger btn-sm mt-2"
                            onClick={() => removeImage("thumbnail")}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Banner */}
                    <div className="form-group">
                      <label>Banner (1260x750 px)</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => handleImageChange(e, "banner")}
                        accept="image/*"
                      />
                      <div className="preview-container mt-2">
                        <img
                          src={banner ? URL.createObjectURL(banner) : BannerURl}
                          alt="Banner Preview"
                          className="img-fluid"
                          style={{ maxWidth: "400px", borderRadius: "6px" }}
                        />
                        {banner && (
                          <button
                            type="button"
                            className="btn btn-danger btn-sm mt-2"
                            onClick={() => removeImage("banner")}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Logo */}
                    <div className="form-group">
                      <label>Channel Logo (150x60 px)</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => handleImageChange(e, "uploadLogo")}
                        accept="image/*"
                      />
                      <div className="preview-container mt-2" style={{ width: "30%" }}>
                        <img
                          src={
                            uploadLogo
                              ? URL.createObjectURL(uploadLogo)
                              : ThumbnailURl
                          }
                          alt="Logo Preview"
                          className="img-fluid"
                          style={{ maxWidth: "150px", borderRadius: "8px" }}
                        />
                        {uploadLogo && (
                          <button
                            type="button"
                            className="btn btn-danger btn-sm mt-2"
                            onClick={() => removeImage("uploadLogo")}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                      {/* <div className="bg-primary mt-2 mb-2 text-center" type="submit" disabled={loading}> */}
                      {/* <button

                        className="btn btn-primary bg-primary text-lg px-10 py-3 rounded-lg w-full flex justify-center items-center"

                      >
                        {loading ? (
                          <ClipLoader loading={loading} size={22} color="#fff" />
                        ) : (
                          "Save"
                        )}
                      </button> */}
                      {/* </div> */}








                    </div>


                    {/* Submit */}

                    <button className="btn btn-primary w-100 mt-3">
                      {loading ? <ClipLoader loading={loading} size={22} color="#fff" /> : "Save"}
                    </button>
                  </form>
                </div>
              </div>
            </div>

            {/* Right: Billing Section */}
            <div className="col-lg-5">
              <div className="card">
                <div className="card-body">
                  <h4 className="mb-3 text-center head-small">Billing - Network Channel</h4>
                  <form>
                    {/* Registration Fee */}
                    <div
                      className="p-3 mb-3 rounded"
                      style={{ backgroundColor: "#fdebd0" }}
                    >
                      <div className="row mb-3">
                        <label className="col-sm-6 col-form-label">
                          One Time Registration Fee<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-6">
                          <div className="input-group">
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="registrationFee"
                              value={billing.registrationFee}
                              onChange={handleBillingChange}
                              min="0"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Subscription Fee Options (Network Channel) */}
                    <div
                      className="p-3 mb-3 rounded"
                      style={{ backgroundColor: "#d6eaf8" }}
                    >
                      <h5 className="mb-3">Subscription Fee</h5>

                      {/* Monthly Payment */}
                      <div className="row align-items-center mb-3">
                        <div className="col-sm-6 d-flex align-items-center gap-2">
                          <input
                            className="form-check-input ms-1"
                            type="radio"
                            name="paymentType"
                            value="monthly"
                            checked={billing.paymentType === "monthly"}
                            onChange={handleBillingChange}
                          />
                          <label className="mb-0 ms-4">
                            Pay Monthly <span className="text-danger">*</span>
                          </label>
                        </div>

                        <div className="col-sm-6 d-flex justify-content-sm-end">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="monthlyFee"
                              value={billing.monthlyFee}
                              onChange={handleBillingChange}
                              min="0"
                              required
                              disabled={billing.paymentType !== "monthly"}
                            />
                          </div>
                        </div>
                      </div>

                      {/* 6 Month Payment */}
                      <div className="row align-items-center mb-3">
                        <div className="col-sm-6">



                          <input
                            className="form-check-input ms-1"
                            type="radio"
                            name="paymentType"
                            value="sixMonths"
                            checked={billing.paymentType === "sixMonths"}
                            onChange={handleBillingChange}
                          />





                          <label className="mb-0 ms-4">
                            Pay for 6 Months <span className="text-danger">*</span>
                          </label>
                        </div>

                        <div className="col-sm-6 d-flex justify-content-sm-end">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="sixMonthFee"
                              value={billing.sixMonthFee}
                              onChange={handleBillingChange}
                              min="0"
                              required
                              disabled={billing.paymentType !== "sixMonths"}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Bandwidth */}
                      <div className="row align-items-center mb-3">
                        <label className="col-sm-6 col-form-label">
                          Bandwidth <span className="text-danger">*</span>
                        </label>

                        <div className="col-sm-6 d-flex justify-content-sm-end">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <input
                              type="number"
                              className="form-control"
                              name="bandwidth"
                              value={billing.bandwidth}
                              onChange={handleBillingChange}
                              min="0"
                              required
                            />
                            <span className="input-group-text">GB</span>
                          </div>
                        </div>
                      </div>

                      {/* Space */}
                      <div className="row align-items-center">
                        <label className="col-sm-6 col-form-label">
                          Space <span className="text-danger">*</span>
                        </label>

                        <div className="col-sm-6 d-flex justify-content-sm-end">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <input
                              type="number"
                              className="form-control"
                              name="space"
                              value={billing.space}
                              onChange={handleBillingChange}
                              min="0"
                              required
                            />
                            <span className="input-group-text">GB</span>
                          </div>
                        </div>
                      </div>
                    </div>

                  </form>
                  <hr />
                  {/* Billing-Channel Section */}
                  <h4 className="mb-3 text-center head-small">Billing - Channel</h4>
                  <form>
                    <div
                      className="p-3 mb-3 rounded"
                      style={{ backgroundColor: "#fdebd0" }}
                    >
                      <div className="row mb-3 ">
                        <label className="col-sm-6 col-form-label">
                          One Time Registration Fee<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-6">
                          <div className="input-group">
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="Channel_registrationFee"
                              value={billingChannel.Channel_registrationFee}
                              onChange={handleBillingChannelChange}
                              min="0"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="p-3 mb-3 rounded"
                      style={{ backgroundColor: "#d6eaf8" }}
                    >
                      <h5 className="mb-3">Channel Subscription Fee</h5>

                      {/* Channel Monthly option row */}
                      <div className="row align-items-center mb-2">
                        <div className="col-sm-6">
                          <label className="mb-0">Pay Monthly<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-sm-6">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="channel_monthlyFee"
                              value={billingChannel.channel_monthlyFee}
                              onChange={handleBillingChannelChange}
                              min="0"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      {/* Channel 6-month option row */}
                      <div className="row align-items-center mb-3">
                        <div className="col-sm-6">
                          <label className="mb-0">Pay for 6 Months<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-sm-6">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="channel_sixMonthFee"
                              value={billingChannel.channel_sixMonthFee}
                              onChange={handleBillingChannelChange}
                              min="0"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      {/* Channel Bandwidth */}
                      <div className="row mb-3">
                        <label className="col-sm-6 col-form-label">
                          Channel Bandwidth<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-6">
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              name="channel_bandwidth"
                              value={billingChannel.channel_bandwidth}
                              onChange={handleBillingChannelChange}
                              min="0"
                              required
                            />
                            <span className="input-group-text">GB</span>
                          </div>
                        </div>
                      </div>

                      {/* Channel Space */}
                      <div className="row mb-3">
                        <label className="col-sm-6 col-form-label">
                          Channel Space<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-6">
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              name="channel_space"
                              value={billingChannel.channel_space}
                              onChange={handleBillingChannelChange}
                              min="0"
                              required
                            />
                            <span className="input-group-text">GB</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* End Billing Section */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AddVideoCategory;
